import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageWrapper from "./PageWrapper";
import { useQuizContext } from "./QuizContext";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import "./SignupCommon.css";

const SignupPage10: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const { setAnswer } = useQuizContext();

  const handleOptionClick = (option: string) => {
    setSelectedOption(option);
  };

  const handleNext = () => {
    if (selectedOption) {
      localStorage.setItem(
        "previous_medication_duration",
        JSON.stringify({
          key: "previous_medication_duration",
          value: selectedOption,
          id: 18026060,
        })
      );
      setAnswer("previous_medication_duration", selectedOption, "18026060");
      localStorage.setItem("step-6-completed", "true");
    }
  };
  const navigate = useNavigate();

  useEffect(() => {
    const step5Completed = localStorage.getItem("step-5-completed");
    if (step5Completed) {
      navigate("/getting-started/step-6",{ replace: true });
    } else {
      navigate("/getting-started/step-5",{ replace: true });
    }
  }, []);

  useEffect(() => {
    const savedPreviousMedicationDuration = localStorage.getItem(
      "previous_medication_duration"
    );

    if (savedPreviousMedicationDuration) {
      const parsedPreviousMedicationDuration = JSON.parse(
        savedPreviousMedicationDuration
      );
      setSelectedOption(parsedPreviousMedicationDuration.value);
    }
  }, []);

  const options = [
    "I’ve never tried dieting or exercise",
    "Less than 6 months",
    "6-12 months",
    "Several years",
    "My whole life",
  ];

  const step = 6;

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={60} step={step} />
        <div className="signup-content">
          <p className="signup-intro">
            How long have you been trying to get to a healthier weight?
          </p>
          <div className="options">
            {options.map((option) => (
              <label
                key={option}
                className={selectedOption === option ? "selected" : ""}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>
          <Link to="/getting-started/step-6b">
            <button
              className="next-btn sticky-btn"
              onClick={handleNext}
              disabled={!selectedOption}
            >
              Continue →
            </button>
          </Link>
        </div>
      </div>
    </PageWrapper>
  );
};

export default SignupPage10;
